import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1ed4dd1b from 'nuxt_plugin_plugin_1ed4dd1b' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_56081775 from 'nuxt_plugin_sentryserver_56081775' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_1f62b426 from 'nuxt_plugin_sentryclient_1f62b426' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_recaptcha_2fdc66a0 from 'nuxt_plugin_recaptcha_2fdc66a0' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_libplugin12717a9a_5b537e88 from 'nuxt_plugin_libplugin12717a9a_5b537e88' // Source: ./lib.plugin.12717a9a.js (mode: 'client')
import nuxt_plugin_plugin_83059e18 from 'nuxt_plugin_plugin_83059e18' // Source: ./plugin.js (mode: 'all')
import nuxt_plugin_clipboard_7ec4bb91 from 'nuxt_plugin_clipboard_7ec4bb91' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_nuxtuseragent_e34acb8c from 'nuxt_plugin_nuxtuseragent_e34acb8c' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_index_4f3a0c80 from 'nuxt_plugin_index_4f3a0c80' // Source: ./infinitescroll/components/index.js (mode: 'all')
import nuxt_plugin_axios_2944ce9e from 'nuxt_plugin_axios_2944ce9e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_toast_90e43540 from 'nuxt_plugin_toast_90e43540' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_b0cc934e from 'nuxt_plugin_cookieuniversalnuxt_b0cc934e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_image_5336d4a8 from 'nuxt_plugin_image_5336d4a8' // Source: ./image.js (mode: 'all')
import nuxt_plugin_vuescrollto_30ba7438 from 'nuxt_plugin_vuescrollto_30ba7438' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_moment_e1fde1f2 from 'nuxt_plugin_moment_e1fde1f2' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_workbox_0c2aa58d from 'nuxt_plugin_workbox_0c2aa58d' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_6e7fe0c0 from 'nuxt_plugin_metaplugin_6e7fe0c0' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_653095d8 from 'nuxt_plugin_iconplugin_653095d8' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_VueAwesomeSwiper_72dcfbac from 'nuxt_plugin_VueAwesomeSwiper_72dcfbac' // Source: ../plugins/VueAwesomeSwiper.js (mode: 'all')
import nuxt_plugin_Vuelidate_384d8988 from 'nuxt_plugin_Vuelidate_384d8988' // Source: ../plugins/Vuelidate.js (mode: 'all')
import nuxt_plugin_smoothscroll_4a637016 from 'nuxt_plugin_smoothscroll_4a637016' // Source: ../plugins/smooth-scroll (mode: 'client')
import nuxt_plugin_vuejsmodal_0719e4a0 from 'nuxt_plugin_vuejsmodal_0719e4a0' // Source: ../plugins/vue-js-modal.js (mode: 'all')
import nuxt_plugin_coollightboxpinch_b3993830 from 'nuxt_plugin_coollightboxpinch_b3993830' // Source: ../plugins/cool-lightbox-pinch.js (mode: 'client')
import nuxt_plugin_vuemask_613243e6 from 'nuxt_plugin_vuemask_613243e6' // Source: ../plugins/vue-mask.js (mode: 'all')
import nuxt_plugin_casewords_209a4398 from 'nuxt_plugin_casewords_209a4398' // Source: ../plugins/case-words.js (mode: 'all')
import nuxt_plugin_numberformat_24c7baf3 from 'nuxt_plugin_numberformat_24c7baf3' // Source: ../plugins/number-format.js (mode: 'all')
import nuxt_plugin_customnotification_50d8a932 from 'nuxt_plugin_customnotification_50d8a932' // Source: ../plugins/custom-notification.js (mode: 'all')
import nuxt_plugin_vuecoollightbox_56b7c7c8 from 'nuxt_plugin_vuecoollightbox_56b7c7c8' // Source: ../plugins/vue-cool-lightbox.js (mode: 'all')
import nuxt_plugin_nuxtrouterhackplugin_75029b09 from 'nuxt_plugin_nuxtrouterhackplugin_75029b09' // Source: ../plugins/nuxt-router-hack-plugin.js (mode: 'all')
import nuxt_plugin_vuelazyload_37761242 from 'nuxt_plugin_vuelazyload_37761242' // Source: ../plugins/vue-lazyload.js (mode: 'all')
import nuxt_plugin_getcookiesopt_11b12a60 from 'nuxt_plugin_getcookiesopt_11b12a60' // Source: ../plugins/get-cookies-opt.js (mode: 'all')
import nuxt_plugin_yandexcommerce_db9cc512 from 'nuxt_plugin_yandexcommerce_db9cc512' // Source: ../plugins/yandex-commerce.js (mode: 'all')
import nuxt_plugin_device_f02ba42c from 'nuxt_plugin_device_f02ba42c' // Source: ../plugins/device.js (mode: 'all')
import nuxt_plugin_vkgoalwr_5b4bc9a3 from 'nuxt_plugin_vkgoalwr_5b4bc9a3' // Source: ../plugins/vk-goal-wr.js (mode: 'all')
import nuxt_plugin_plugin_34419d2d from 'nuxt_plugin_plugin_34419d2d' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"linza.ru","htmlAttrs":{"lang":"ru"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover, maximum-scale=1, user-scalable=no"},{"hid":"metadescription","name":"description","content":""},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"theme-color","content":"#ffffff"},{"name":"yandex-verification","content":"43b60ca86a8a6654"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#a72681"},{"rel":"preload","as":"image","href":"\u002Flogo-full.svg","type":"image\u002Fsvg+xml"},{"rel":"preload","href":"\u002Ffonts\u002Ffonts.css","as":"style"},{"rel":"stylesheet","href":"\u002Ffonts\u002Ffonts.css"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FGilroy-UltraLight.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FGilroy-Thin.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FGilroy-SemiBold.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FGilroy-Regular.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FGilroy-Medium.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FGilroy-Light.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FGilroy-Black.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FGilroy-Bold.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FGilroy-ExtraBold.woff2","crossorigin":"anonymous"}],"script":[{"type":"text\u002Fjavascript","body":true,"src":"\u002Fjs\u002Fsourcebuster.min.js","async":true},{"type":"text\u002Fjavascript","body":true,"src":"\u002Fjs\u002Fcarrotquest.js","async":true},{"type":"text\u002Fjavascript","body":true,"src":"\u002Fjs\u002Fvk-retargeting.js","async":true},{"type":"text\u002Fjavascript","body":true,"src":"\u002Fjs\u002FResizeSensor.js","async":true},{"type":"text\u002Fjavascript","body":true,"src":"\u002Fjs\u002Fsticky-sidebar.min.js","async":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1ed4dd1b === 'function') {
    await nuxt_plugin_plugin_1ed4dd1b(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_56081775 === 'function') {
    await nuxt_plugin_sentryserver_56081775(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_1f62b426 === 'function') {
    await nuxt_plugin_sentryclient_1f62b426(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_2fdc66a0 === 'function') {
    await nuxt_plugin_recaptcha_2fdc66a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libplugin12717a9a_5b537e88 === 'function') {
    await nuxt_plugin_libplugin12717a9a_5b537e88(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_83059e18 === 'function') {
    await nuxt_plugin_plugin_83059e18(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_7ec4bb91 === 'function') {
    await nuxt_plugin_clipboard_7ec4bb91(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_e34acb8c === 'function') {
    await nuxt_plugin_nuxtuseragent_e34acb8c(app.context, inject)
  }

  if (typeof nuxt_plugin_index_4f3a0c80 === 'function') {
    await nuxt_plugin_index_4f3a0c80(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2944ce9e === 'function') {
    await nuxt_plugin_axios_2944ce9e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_90e43540 === 'function') {
    await nuxt_plugin_toast_90e43540(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_b0cc934e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_b0cc934e(app.context, inject)
  }

  if (typeof nuxt_plugin_image_5336d4a8 === 'function') {
    await nuxt_plugin_image_5336d4a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_30ba7438 === 'function') {
    await nuxt_plugin_vuescrollto_30ba7438(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_e1fde1f2 === 'function') {
    await nuxt_plugin_moment_e1fde1f2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_0c2aa58d === 'function') {
    await nuxt_plugin_workbox_0c2aa58d(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_6e7fe0c0 === 'function') {
    await nuxt_plugin_metaplugin_6e7fe0c0(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_653095d8 === 'function') {
    await nuxt_plugin_iconplugin_653095d8(app.context, inject)
  }

  if (typeof nuxt_plugin_VueAwesomeSwiper_72dcfbac === 'function') {
    await nuxt_plugin_VueAwesomeSwiper_72dcfbac(app.context, inject)
  }

  if (typeof nuxt_plugin_Vuelidate_384d8988 === 'function') {
    await nuxt_plugin_Vuelidate_384d8988(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_smoothscroll_4a637016 === 'function') {
    await nuxt_plugin_smoothscroll_4a637016(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsmodal_0719e4a0 === 'function') {
    await nuxt_plugin_vuejsmodal_0719e4a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_coollightboxpinch_b3993830 === 'function') {
    await nuxt_plugin_coollightboxpinch_b3993830(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_613243e6 === 'function') {
    await nuxt_plugin_vuemask_613243e6(app.context, inject)
  }

  if (typeof nuxt_plugin_casewords_209a4398 === 'function') {
    await nuxt_plugin_casewords_209a4398(app.context, inject)
  }

  if (typeof nuxt_plugin_numberformat_24c7baf3 === 'function') {
    await nuxt_plugin_numberformat_24c7baf3(app.context, inject)
  }

  if (typeof nuxt_plugin_customnotification_50d8a932 === 'function') {
    await nuxt_plugin_customnotification_50d8a932(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecoollightbox_56b7c7c8 === 'function') {
    await nuxt_plugin_vuecoollightbox_56b7c7c8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtrouterhackplugin_75029b09 === 'function') {
    await nuxt_plugin_nuxtrouterhackplugin_75029b09(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelazyload_37761242 === 'function') {
    await nuxt_plugin_vuelazyload_37761242(app.context, inject)
  }

  if (typeof nuxt_plugin_getcookiesopt_11b12a60 === 'function') {
    await nuxt_plugin_getcookiesopt_11b12a60(app.context, inject)
  }

  if (typeof nuxt_plugin_yandexcommerce_db9cc512 === 'function') {
    await nuxt_plugin_yandexcommerce_db9cc512(app.context, inject)
  }

  if (typeof nuxt_plugin_device_f02ba42c === 'function') {
    await nuxt_plugin_device_f02ba42c(app.context, inject)
  }

  if (typeof nuxt_plugin_vkgoalwr_5b4bc9a3 === 'function') {
    await nuxt_plugin_vkgoalwr_5b4bc9a3(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_34419d2d === 'function') {
    await nuxt_plugin_plugin_34419d2d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    const { route } = router.resolve(app.context.route.fullPath)
    // Ignore 404s rather than blindly replacing URL
    if (!route.matched.length && process.client) {
      return resolve()
    }
    router.replace(route, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
